import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../Styles/Order.css";
import locales from "../../../_constants/locales";

class RecommendedItem extends Component {
    getItemPicture(sku) {
        return `https://static.koboscm.com/images/RakutenKobo/devices/${sku}.png`;
    }

    handleViewItem() {
        window.open(this.props.item.store_data.product_url, "_blank");
    }

    render() {
        return (
            <div className="recommended-item" id={this.props.id}>
                <img className="recommended-item-image" src={this.getItemPicture(this.props.item.sku)} alt="" />

                <div>
                    <p className="recommended-item-title">{this.props.item.title}</p>
                    {this.props.item.store_data.variant_title && this.props.item.store_data.variant_title !== "Default Title" && (
                        <p className="recommended-item-variant-title">
                            {this.props.item.store_data.variant_title !== "Default Title" ? this.props.item.store_data.variant_title : ""}
                        </p>
                    )}
                </div>

                {this.props.item.store_data.product_url && (
                    <div>
                        <button className="view-item-button" onClick={this.handleViewItem.bind(this)}>
                            {locales[this.props.store[0]][this.props.language].ORDER_PAGE.ITEMS_SECTION.VIEW_ITEM}
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default withRouter(RecommendedItem);



// WEBPACK FOOTER //
// ./src/views/Order/components/_RecommendedItem.jsx